import { useMemo } from "react";
import { useSelector } from "react-redux";
import {
  SidesheetType,
  selectCurrentSidesheet,
  selectFocusedBlockedInterval,
} from "store/calendarSidebarSlice";
import styles from "./BlockedIntervalSidesheet.module.scss";
import BlockedIntervalDetails from "./components/blocked-interval-details/BlockedIntervalDetails";
import EditBlockedInterval from "./components/edit-blocked-interval/EditBlockedInterval";

const BlockedIntervalSidesheet = () => {
  const currentSidesheet = useSelector(selectCurrentSidesheet);
  const focusedBlockedInterval = useSelector(selectFocusedBlockedInterval);

  const isEditing = useMemo(
    () => currentSidesheet === SidesheetType.EditBlockedInterval,
    [currentSidesheet],
  );

  if (!focusedBlockedInterval) {
    return null;
  }

  return (
    <div className={styles["container"]}>
      {isEditing ? (
        <EditBlockedInterval blockedInterval={focusedBlockedInterval} />
      ) : (
        <BlockedIntervalDetails blockedInterval={focusedBlockedInterval} />
      )}
    </div>
  );
};

export default BlockedIntervalSidesheet;
